import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetBoardNewsById } from '../hooks/boardNewsQueries';
import NewsEditDraft from './NewsEditDraft';
import NewsEditPublished from './NewsEditPublished';

const NewsDetailPage = () => {
    const { id } = useParams<{ id: string }>();

    const { data } = useGetBoardNewsById(+id);

    if (!data?.published_at) {
        return <NewsEditDraft />;
    }

    return <NewsEditPublished />;
};

export default NewsDetailPage;
